<div id="main-container" class="display-flex" style="margin-left: 10px;margin-top: 10px;">
    <app-detailed-bulk-export-view #detail_view_component
            (buttonAction)="onButtonAction($event)"></app-detailed-bulk-export-view>
</div>